export default __webpack_public_path__ + "f1a5e2637e2b94b3856064a845f4ebf4.png";